import React from 'react';

export default ({ image, id, link, quality, lang, deleteLink }) => (
    <div className="link">
        <div>
            <img src={image} alt="thumbnail" />
            <span
                onClick={() => deleteLink(id, lang)}
            >
                    X
                </span>
        </div>
        <div><span><b>Quality: </b></span> {quality}</div>
        <div>
            <span><b>Url: </b></span>
            <a href={link} target="_blunk">{link}</a>
        </div>
    </div>
);
